import { useTranslation } from "react-i18next";

import LoadingSpinner from "../../../../UI/spinner";
import PagnationComponent from "../../../../UI/pagnationComponent";
import SingleAttendance from "../singleAttendance";
import SubHeaderFilter from "../subheaderfilter";
import ErrorMessage from "../../../../UI/error";
import NoData from "../../../../UI/nodata";

const AttendanceDataTable = ({
  componentRef,
  responeMessage,
  setSbEmployeId,
  refetch,
  sb_branch_id,
  setDateFrom,
  setSbBranchId,
  setDateTo,
  currentPage,
  attendances,
  isLoading,
  data,
  setCurrentPage,
  totalItems,
  error,
}) => {
  const { t } = useTranslation();

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    <div className="container-fluid">
      <SubHeaderFilter
        t={t}
        branchId={sb_branch_id}
        setSbEmployeId={setSbEmployeId}
        setSbBranchId={setSbBranchId}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
      />

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {attendances.length === 0 ? (
            <NoData responeMessage={responeMessage} />
          ) : (
            <>
              {!data ? (
                <div>No data available</div>
              ) : (
                <div className="card">
                  <div className="table-responsive">
                    <table
                      className="table table-striped table-hover"
                      ref={componentRef}>
                      <thead>
                        <tr>
                          <th>{t("employee")}</th>
                          <th>{t("in_time")}</th>
                          <th>{t("out_time")}</th>
                          <th>{t("late_time")}</th>
                          <th>{t("work_hours")}</th>
                          <th>{t("Actions")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {attendances.map((attend) => (
                          <SingleAttendance
                            key={attend.id}
                            attend={attend}
                            refetch={refetch}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}

      {attendances.length !== 0 && (
        <div className="mb-3 d-flex justify-content-center">
          <PagnationComponent
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            totalItems={totalItems}
          />
        </div>
      )}
    </div>
  );
};

export default AttendanceDataTable;
